import { render, staticRenderFns } from "./UsersForm.vue?vue&type=template&id=65ca2156&scoped=true"
import script from "./UsersForm.vue?vue&type=script&lang=js"
export * from "./UsersForm.vue?vue&type=script&lang=js"
import style0 from "./UsersForm.vue?vue&type=style&index=0&id=65ca2156&prod&lang=scss&scoped=true"
import style1 from "./UsersForm.vue?vue&type=style&index=1&id=65ca2156&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ca2156",
  null
  
)

export default component.exports